import NavBar from './Components/NavBar';
import Intro from './Components/Intro'
import logo from './logo.svg';
import './App.css'
import Services from './Components/Services';
import Experience from './Components/Experience';
import Work from './Components/Work';
import Portfolio from './Components/Portfolio';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import {themeContext} from './Context';
import {useContext} from 'react';

function App() {
  
  const theme=useContext(themeContext);
  const darkMode=theme.state.darkMode;
  
  return (
    <div className='App' 
    style={{background :darkMode? 'black' :'',
    color :darkMode? 'white': ''
  }}
    >
      <NavBar />
      <Intro />
      <Services />
      <Experience />
      <Portfolio />
      <Contact />
      <Footer />
      
    </div>
  );
}

export default App;
